import React from 'react';
import { Link } from 'react-router-dom';
class NotFoundPage extends React.Component {
  render() {
    return (
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            color: 'grey',
          }}
        >
          {' '}
          404 not found!
        </h1>
        <p style={{ textAlign: 'center', fontSize: '26px' }}>
          <Link to="/">Go to Home </Link>
        </p>
      </div>
    );
  }
}
export default NotFoundPage;
